import ShieldRecommender from "~components/shield-recommender/shield-recommender";
import * as React from 'react';
export default {
  ShieldRecommender,
  React
};